<template>
  <div class="mini-divider-component inner" ref="divider"/>
</template>
<script>
  export default {
    name: 'mini-divider-component',
    props: [ 'height' ],
    mounted() {
      this.$refs.divider.style.height = `${this.height || 4}px`
    },
  }
</script>
<style scoped lang="scss">
  .mini-divider-component {
    margin-top: 5px;
    margin-bottom: 5px;
    background: $color-1;
    background: linear-gradient(90deg, $color-5 0%, $color-1 100%);
  }
</style>